import React, { useState, useEffect } from "react";
import { Tooltip, IconButton, CircularProgress } from "@mui/material";
import { Cloud, CloudOff } from "@mui/icons-material";
import ApiService from "../../services/api.service";
import { getServerStatus, subscribeServerStatus } from "../../services/connection-status";

export function ServerStatus() {
  // Reactive — driven by real request outcomes via the axios interceptors. No polling.
  const [status, setStatus] = useState(getServerStatus()); // "online" | "offline" | "checking"

  useEffect(() => subscribeServerStatus(setStatus), []);

  // Manual retry only (a one-off health ping) — its outcome flows back through the
  // interceptor and updates the shared status. Not a background poll.
  const handleRetry = async () => {
    try {
      await ApiService.get("/api/health", { timeout: 5000 });
    } catch (e) {
      // status is updated by the interceptor; nothing else to do here
    }
  };

  const getStatusColor = () => {
    switch (status) {
      case "online":
        return "#22c55e"; // green-500
      case "offline":
        return "#ef4444"; // red-500
      case "checking":
      default:
        return "#f59e0b"; // amber-500
    }
  };

  const getTooltipText = () => {
    switch (status) {
      case "online":
        return "Thaklis Server: Online";
      case "offline":
        return "Thaklis Server: Offline - Click to retry";
      case "checking":
      default:
        return "Checking server status...";
    }
  };

  return (
    <Tooltip
      title={
        <span style={{ whiteSpace: 'pre-line' }}>
          {getTooltipText()}
        </span>
      }
      arrow
    >
      <IconButton
        onClick={status === "offline" ? handleRetry : undefined}
        size="small"
        sx={{
          color: getStatusColor(),
          transition: 'color 0.3s ease',
          '&:hover': {
            backgroundColor: 'rgba(0,0,0,0.04)',
          }
        }}
      >
        {status === "checking" ? (
          <CircularProgress size={20} sx={{ color: getStatusColor() }} />
        ) : status === "online" ? (
          <Cloud />
        ) : (
          <CloudOff />
        )}
      </IconButton>
    </Tooltip>
  );
}

export default ServerStatus;
